import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {NGXLogger} from 'ngx-logger';
import { Segnalazione } from '../models/segnalazione.model';


@Injectable({
  providedIn: 'root',
})
export class SegnalazioniService{
  apiUrl: string = environment.apiUrl+"segnalazione";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger

    ) {}

  get(): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl, httpOptions);
  }

  getByID(idSegnalazione:string): Observable<Segnalazione> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get<Segnalazione>(this.apiUrl+"/"+idSegnalazione, httpOptions);
  }

  getLast5(): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"?filter=last5", httpOptions);
  }

  getLastNuove(): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"?filter=lastNew5", httpOptions);
  }

  getPianificabili(): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"?filter=pianificabili", httpOptions);
  }

  getStorico(idSegnalazione:number): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/"+idSegnalazione+"/storico", httpOptions);
  }




  crea(segnalazione:Segnalazione): Observable<any> {

    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl, segnalazione, httpOptions);
  }



  elimina(idsegnalazione:string): Observable<any> {
    let url = this.apiUrl +"/"+idsegnalazione;
    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(url, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('eliminasegnalazione', []))
    );
  }
  modifica(segnalazione:Segnalazione): Observable<any> {

    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(this.apiUrl+"/"+segnalazione.id, segnalazione, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('modificasegnalazione', []))
    );
  }
  modificaPriorita(segnalazione:Segnalazione): Observable<any> {
    let url = this.apiUrl+"/"+segnalazione.id+"/priorita";
    // this.logger.info("*** modificaPriorita @ "+ url);

    const headers = {
      //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(url, segnalazione, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('modificasegnalazione', []))
    );
  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
   private handleError = <T>(operation = 'operation', result?: T) => {
    return (error: any): Observable<T> => {

/*      // TODO: send the error to remote logging infrastructure
      this.logger.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.info(`${operation} failed: ${error.message}`);*/

      /*this.errorHandler.dialogConfig = {...this.dialogConfig};
      this.errorHandler.handleError(error);*/



      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  };
}
